import React, { useState } from 'react'
import styled from 'styled-components'
import Modal from 'components/Modal'
import DeleteIcon from '@mui/icons-material/Delete'
import Button from 'components/Button'
import { removeTeacher } from 'services/TeachersService'
import { fetchTeachersListRoutine } from 'modules/teachers/ducks/actions'
import { useDispatch } from 'react-redux'

const DeleteTeacherModal = ({ teacher }) => {
  const [open, setOpen] = useState(false)
  const dispatch = useDispatch()

  const handleOpen = e => {
    e.stopPropagation()
    setOpen(true)
  }
  const handleClose = e => {
    e && e.stopPropagation()
    setOpen(false)
  }

  const fetchTeachersList = () => {
    dispatch(fetchTeachersListRoutine())
    handleClose()
  }

  const handleDelete = () => {
    removeTeacher({
      teacher,
      callback: fetchTeachersList
    })
  }

  return (
    <>
      <Trigger onClick={handleOpen}>
        <StyledIcon />
      </Trigger>
      <Modal
        title='Usuń'
        open={open}
        onClose={handleClose}
      >
        Czy na pewno chcesz usunąć nauczyciela <TeacherName>{teacher.name}</TeacherName>?
        <ButtonsWrapper>
          <Button onClick={handleClose} color='secondary'>Anuluj</Button>
          <Button color='primary' onClick={handleDelete}>Usuń</Button>
        </ButtonsWrapper>
      </Modal>
    </>
  )
}

export default DeleteTeacherModal

const Trigger = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`

const StyledIcon = styled(DeleteIcon)`
  transition: all .3s;

  &:hover {
    color: ${({ theme }) => theme.colors.secondary.main};
  }
`

const TeacherName = styled.span`
  color: ${({ theme }) => theme.colors.secondary.main};
  font-weight: bold;
`

const ButtonsWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
`
